import _default from "keen-slider";

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        InnerBlocks
    } = window.wp.editor;

    const ALLOWED_BLOCKS = ['custom-gutenberg/hero-slide'];

    registerBlockType('custom-gutenberg/hero-slider', {
        // built-in attributes
        title: 'Hero Slider',
        description: 'Custom Hero Slider',
        icon: 'slides',
        category: 'custom-components',
        example: {},

        // built-in functions
        edit() {

            const MY_TEMPLATE = [
                [ 'custom-gutenberg/hero-slide', {} ],
            ];


            return (
                <div className="position-relative">
                    <div id="hero-slider" className="keen-slider mb-4" style={ { opacity: '1' } }>
                        <InnerBlocks allowedBlocks={ ALLOWED_BLOCKS } template={ MY_TEMPLATE } />
                    </div>
                    <div class="container-fluid keen-slider__arrows">
                        <div data-dir="prev"><i
                                class="la la-arrow-left"></i></div>
                        <div data-dir="next"><i
                                class="la la-arrow-right"></i></div>
                    </div>
                    <div class="keen-slider__pager">
                        <div class="keen-slider__pager-buttons"></div>
                    </div>
                </div>
            );
        },

        save() {

            return (
                <div className="home-hero position-relative">
                    <div id="hero-slider" className="keen-slider bg-dark shadow mb-4">
                        <InnerBlocks.Content />
                    </div>
                    <div class="container-fluid keen-slider__arrows">
                        <div data-dir="prev"><i
                                class="la la-arrow-left"></i></div>
                        <div data-dir="next"><i
                                class="la la-arrow-right"></i></div>
                    </div>
                    <div class="keen-slider__pager">
                        <div class="keen-slider__pager-buttons"></div>
                    </div>
                </div>
            );
        },
    });
}